import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { useOnMount } from '../../../hooks';
import * as IssuesV2Store from '../../../redux/issuesV2';
import type { ProjectScope } from '../../../../shared/issuesV2';
import type { IssuesContainerProps } from '../IssuesContainer';

import ComparisonContent from './ComparisonContent';
import EmptyState from './EmptyState';

const IssueComparisonContainer: VoidFunctionComponent<IssuesContainerProps> = ({
  params,
  location,
  project,
  revision,
  router,
}) => {
  const dispatch = useDispatch();

  const scope = useSelector(IssuesV2Store.selectors.getScope) as ProjectScope;

  useOnMount(
    () => dispatch(IssuesV2Store.actions.enterComparisonMode()),
    () => dispatch(IssuesV2Store.actions.exitComparisonMode()),
  );

  if (
    !scope.compareTo ||
    !scope.compareTo.revision ||
    // If they've selected the revision we're currently on, consider it empty.
    scope.compareTo.revision === scope.revision) {
    return (
      <EmptyState />
    );
  }

  return (
    <ComparisonContent params={params} location={location} project={project} revision={revision} router={router} />
  );
};

export default IssueComparisonContainer;
